import { render } from "./4.QualitySection.vue?vue&type=template&id=316e286f&scoped=true"
import script from "./4.QualitySection.vue?vue&type=script&lang=js"
export * from "./4.QualitySection.vue?vue&type=script&lang=js"

import "./4.QualitySection.vue?vue&type=style&index=0&id=316e286f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316e286f"]])

export default __exports__